import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16512454"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["d", "stroke", "stroke-width", "stroke-dasharray", "marker-start", "marker-end"]
const _hoisted_3 = ["d"]

import { computed } from 'vue'
import type { PPTLineElement } from '@/types/slides'
import { getLineElementPath } from '@/utils/element'
import type { ContextmenuItem } from '@/components/Contextmenu/types'
import useElementShadow from '@/views/components/element/hooks/useElementShadow'

import LinePointMarker from './LinePointMarker.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    elementInfo: {},
    selectElement: { type: Function },
    contextmenus: { type: Function }
  },
  setup(__props: any) {

const props = __props

const handleSelectElement = (e: MouseEvent | TouchEvent) => {
  if (props.elementInfo.lock) return
  e.stopPropagation()

  props.selectElement(e, props.elementInfo)
}

const shadow = computed(() => props.elementInfo.shadow)
const { shadowStyle } = useElementShadow(shadow)

const svgWidth = computed(() => {
  const width = Math.abs(props.elementInfo.start[0] - props.elementInfo.end[0])
  return width < 24 ? 24 : width
})
const svgHeight = computed(() => {
  const height = Math.abs(props.elementInfo.start[1] - props.elementInfo.end[1])
  return height < 24 ? 24 : height
})

const lineDashArray = computed(() => {
  if (props.elementInfo.style !== 'dashed') return '0 0'
  const size = props.elementInfo.width
  return size <= 8 ? `${size * 5} ${size * 2.5}` : `${size * 5} ${size * 1.5}`
})

const path = computed(() => {
  return getLineElementPath(props.elementInfo)
})

return (_ctx: any,_cache: any) => {
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-element-shape", { 'lock': _ctx.elementInfo.lock }]),
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "element-content",
      style: _normalizeStyle({ filter: _unref(shadowStyle) ? `drop-shadow(${_unref(shadowStyle)})` : '' }),
      onMousedown: _cache[0] || (_cache[0] = $event => handleSelectElement($event)),
      onTouchstart: _cache[1] || (_cache[1] = $event => handleSelectElement($event))
    }, [
      (_openBlock(), _createElementBlock("svg", {
        overflow: "visible",
        width: svgWidth.value,
        height: svgHeight.value
      }, [
        _createElementVNode("defs", null, [
          (_ctx.elementInfo.points[0])
            ? (_openBlock(), _createBlock(LinePointMarker, {
                key: 0,
                id: _ctx.elementInfo.id,
                position: "start",
                type: _ctx.elementInfo.points[0],
                color: _ctx.elementInfo.color,
                baseSize: _ctx.elementInfo.width
              }, null, 8, ["id", "type", "color", "baseSize"]))
            : _createCommentVNode("", true),
          (_ctx.elementInfo.points[1])
            ? (_openBlock(), _createBlock(LinePointMarker, {
                key: 1,
                id: _ctx.elementInfo.id,
                position: "end",
                type: _ctx.elementInfo.points[1],
                color: _ctx.elementInfo.color,
                baseSize: _ctx.elementInfo.width
              }, null, 8, ["id", "type", "color", "baseSize"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("path", {
          class: "line-point",
          d: path.value,
          stroke: _ctx.elementInfo.color,
          "stroke-width": _ctx.elementInfo.width,
          "stroke-dasharray": lineDashArray.value,
          fill: "none",
          "marker-start": _ctx.elementInfo.points[0] ? `url(#${_ctx.elementInfo.id}-${_ctx.elementInfo.points[0]}-start)` : '',
          "marker-end": _ctx.elementInfo.points[1] ? `url(#${_ctx.elementInfo.id}-${_ctx.elementInfo.points[1]}-end)` : ''
        }, null, 8, _hoisted_2),
        _withDirectives(_createElementVNode("path", {
          class: "line-path",
          d: path.value,
          stroke: "transparent",
          "stroke-width": "20",
          fill: "none"
        }, null, 8, _hoisted_3), [
          [_directive_contextmenu, _ctx.contextmenus]
        ])
      ], 8, _hoisted_1))
    ], 36)
  ], 6))
}
}

})